import { lotame } from '@tunein/web-common';
import { storeSingleton } from 'src/client/store/storeSingleton';
import oneTrust from 'src/common/consent/OneTrust';
import {
  selectGdprApplies,
  selectGdprTcString,
  selectIsOptedOutOfTargeting,
  selectUsPrivacyString,
} from 'src/common/selectors/app';
import { canShowPersonalizedAds } from 'src/common/utils/ads/canShowPersonalizedAds';

export async function buildConsentData() {
  await oneTrust.ready;

  const state = storeSingleton.state;
  const gdprApplies = selectGdprApplies(state);
  const audiences = lotame.getAudiences();
  const isOptedOutOfTargeting = selectIsOptedOutOfTargeting(state);

  return {
    gdprApplies,
    gdprTcString: selectGdprTcString(state),
    usPrivacyString: selectUsPrivacyString(state),
    optedInGeneralVendorIds: gdprApplies ? await oneTrust.getOptedInGeneralVendorIds() : undefined,
    isTargetingEnabled: !isOptedOutOfTargeting,
    // The TCF purpose bits live only in the app, so consumers cannot derive this for themselves.
    // Shared with the legacy ad path, which gates its own ppid on the same predicate.
    isPersonalizedAdsAllowed: canShowPersonalizedAds(state),
    audiences,
  };
}
